import { StyledHeaderTitle } from "app/pages/website-analysis/audience-overlap/StyledComponents";
import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import { i18nFilter } from "app/filters/i18nFilter";

export const Title = () => {
    const i18n = i18nFilter();
    return (
        <StyledHeaderTitle>
            <BoxTitle tooltip={i18n("analysis.audience.overlap.overtime.title.tooltip")}>
                {i18n("analysis.audience.overlap.overtime.title")}
            </BoxTitle>
        </StyledHeaderTitle>
    );
};
